/** Manual WhatsApp reminder for appointments (opens wa.me). */
import { whatsAppHref } from '@shared/phone';
import { openExternalUrl } from '../../customers/public-api';
import { showError } from '../../shared/ui/appToast';
import type { Appointment } from '../domain/types';

function formatWhen(iso: string): string {
  const d = new Date(iso);
  const day = d.toLocaleDateString('es-AR', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  });
  const time = d.toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit', hour12: false });
  return `${day} a las ${time}`;
}

export function buildAppointmentWhatsAppReminder(params: {
  appointment: Appointment;
  resourceName?: string;
  serviceName?: string;
  storeName?: string;
}): string {
  const { appointment: a, resourceName, serviceName, storeName } = params;
  const bits = [
    `Hola ${a.customerName}, te recuerdo el turno`,
    formatWhen(a.startsAt),
  ];
  if (storeName) bits.push(`en ${storeName}`);
  if (resourceName) bits.push(`con ${resourceName}`);
  if (serviceName) bits.push(`(${serviceName})`);
  bits.push('Te esperamos.');
  return bits.join(' ');
}

/** Opens WhatsApp with a prefilled reminder. Returns false if no phone. */
export async function openAppointmentWhatsAppReminder(params: {
  appointment: Appointment;
  resourceName?: string;
  serviceName?: string;
  storeName?: string;
}): Promise<boolean> {
  const url = whatsAppHref(
    params.appointment.customerPhone,
    buildAppointmentWhatsAppReminder(params),
  );
  if (!url) {
    showError(
      'Sin teléfono',
      'Este turno no tiene teléfono. Editá el turno y cargá uno para recordar por WhatsApp.',
    );
    return false;
  }
  await openExternalUrl(url);
  return true;
}
